/**
 * Custom theme colors for charts - medium-tone pastel colors for better visibility
 */
export const CHART_COLORS = [
  "#818cf8",
  "#a78bfa",
  "#f472b6",
  "#fb923c",
  "#34d399",
  "#60a5fa",
  "#fbbf24",
  "#c084fc",
];
